/**
 * Encode quotes and backslash in query
 */
const encode = (string: string): string => (
  string
    .replace(/\n/g, '')
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
)

const getValue = (value: any, isEnum: boolean): string => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return
  }

  if (typeof value === 'string') {
    return isEnum ? `${encode(value)}` : `"${encode(value)}"`
  }

  if (Array.isArray(value)) {
    let valueArray: any[] = value
    valueArray = valueArray.filter((val) => !(val === undefined || val === null))

    if (!valueArray.length) {
      return
    }

    valueArray = valueArray.map((val) => getValue(val, isEnum))

    return `[${valueArray.join(', ')}]`
  }

  if (typeof value === 'object') {
    const hasEnum = Object.keys(value).includes('isEnum')

    if (!hasEnum) {
      const queryParamsKeysArray = Object.keys(value)
      const reduceFunc = reduceMethod(value, queryParamsKeysArray, isEnum)

      return `{${Object.keys(value).reduce(reduceFunc, ``)}}`
    }

    if (typeof value.value === 'string') {
      return `${encode(value.value)}`
    }

    if (value.value || value.value === false) {
      return value.value
    }

    // wrong enum value
    return
  }

  return value
}

const reduceMethod = (params: { [key: string]: any }, queryParamsKeysArray: any[], isEnum: boolean) =>
  (query: string, param: any, currentIndex: number) => {
    let value = params[param]

    value = getValue(value, isEnum)

    if (typeof value === 'undefined') {
      return query
    }

    // for first item
    if (!currentIndex) {
      return `${query}${param}: ${value}`
    }

    return  `${query}, ${param}: ${value}`
  }

/**
 * Get Query Params For Graphql
 *
 * const query = getGqlQuery('products', {
 *   groups: [ 'Perfumes' ],
 *   availableForQueue: true,
 *   productsFeed: 'ALL_PERFUMES',
 * })
 *
 * // `products(groups: [ "Perfumes" ], availableForQueue: true, productsFeed: "ALL_PERFUMES")`
 *
 * request.post('graphql', {
 *   body: {
 *     query: `{
 *       ${query} {
 *         id
 *         name
 *         brand
 *       }
 *     }`,
 *   },
 * })
 */
const trim = (params) => {
  const isArray = Array.isArray(params)
  const result = isArray ? params : Object.keys(params)
  const initialValue = isArray ? [] : {}

  return result.reduce((result, current) => {
    const value = isArray ? current : params[current]

    if (Array.isArray(value)) {
      result[current] = value
        .filter((item) => !(item === undefined || item === null))
        .map((item) => {
          if (item && typeof item === 'object') {
            return trim(item)
          }

          return item
        })
    }
    else if (value && typeof value === 'object') {
      const hasEnum = Object.keys(value).includes('isEnum')

      if (!hasEnum) {
        result[current] = trim(value)
      }
      else if (value.value || value.value === false) {
        result[current] = {
          value: value.value,
          isEnum: true,
        }
      }
    }
    else if (typeof value !== 'undefined' && value !== null && value !== '') {
      result[current] = value
    }

    return result
  }, initialValue)
}

const getGqlQuery = (name: string, params: { [key: string]: any }, isEnum = false): string => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const trimParams            = trim(params)
    const queryParamsKeysArray  = Object.keys(trimParams)

    const reduceFunc        = reduceMethod(trimParams, queryParamsKeysArray, isEnum)
    const gqlQuery: string  = queryParamsKeysArray.reduce(reduceFunc, ``)

    return gqlQuery ? `${name}(${gqlQuery})` : `${name}`
  }

  console.warn('common/helpers/getters/getGqlQuery: params is not object type')
  return ''
}


export default getGqlQuery
